/*
 * The Signal Zone mock's table row heights, as the custom property `DataTable` and its skeleton read
 * (`--table-row-h-two-line`, 56 by default). The dense lists are 52 (a 36 mark and 8 above and
 * below); Signal history's rows are 60 (12 above and below). On the 4-grid, set on the table's root
 * so the rows, the virtualiser's estimate and the skeleton all follow. A module with no components
 * so a route's pending page may import it (docs/route-loading.md, "Pitfalls").
 */
export const SIGNAL_ROWS_52 = '[--table-row-h-two-line:--spacing(13)]'
export const SIGNAL_ROWS_60 = '[--table-row-h-two-line:--spacing(15)]'

/*
 * Figure column widths. The mock lays each figure at its stated width with a 12px gap; a
 * `DataTable` cell holds that gap in its own 12px side padding, so every figure column but the last
 * is the mock's width PLUS 12 (the last ends on the panel's inset with no right padding). The
 * Company column is `fill`, so the figures hug the right edge at every width.
 */
